import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { requireActiveSubscription, requireRoles } from '@/lib/middleware'
import { Invoices } from '@/features/invoices'

const invoicesSearchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  clientId: z.string().optional().catch(undefined),
  status: z.union([z.string(), z.array(z.string())]).optional().catch(undefined),
  category: z.string().optional().catch(undefined),
  search: z.string().optional().catch(undefined),
  startDate: z.string().optional().catch(undefined),
  endDate: z.string().optional().catch(undefined),
  // Deep-link a single invoice's detail dialog open (assistant "Preview invoice" button).
  invoiceId: z.string().optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/_organization/invoices/')({
  beforeLoad: async () => {
    await requireRoles(['owner', 'admin', 'finance'])
    await requireActiveSubscription()
  },
  component: Invoices,
  validateSearch: invoicesSearchSchema,
})

